import { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import cn from "classnames";
import { Description, Form as FormComponent, Title } from "@/ui";
import styles from "./styles.module.scss";

const RESTRICTED_FORM_ID = "1da47ac9-3163-4499-af6e-4151c68151f0";
const STORAGE_KEY = `form_submitted_${RESTRICTED_FORM_ID}`;
const BLOCK_DURATION_MS = 24 * 60 * 60 * 1000;

export const Form = ({ className, bgColor, textColor, title, titleColor, description, formClassName, form_id }) => {
  const [submitted, setSubmitted] = useState(false);

  const isRestricted = form_id === RESTRICTED_FORM_ID;

  useEffect(() => {
    if (!isRestricted) return;
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const submittedAt = parseInt(stored, 10);
      if (Date.now() - submittedAt < BLOCK_DURATION_MS) {
        setSubmitted(true);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  }, [isRestricted]);

  if (!form_id) {
    return null;
  }

  const handleSubmitDone = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setSubmitted(true);
  };

  if (isRestricted && submitted) {
    return (
      <section className={cn(className, bgColor, textColor)}>
        <Container>
          <div className={formClassName}>
            {title && <Title className={titleColor} title={title} />}
            <div className={styles.successMessage}>
              <div className={styles.successIcon}>
                <svg viewBox="0 0 24 24" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <p className={styles.successTitle}>Thank you for the submission!</p>
              <p className={styles.successText}>You have already submitted your CV.</p>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  return (
    <section className={cn(className, bgColor, textColor)}>
      <Container>
        <div className={formClassName}>
          {title && <Title className={titleColor} title={title} />}
          {description && <Description description={description} />}
          <FormComponent formId={form_id} onSubmitDone={isRestricted ? handleSubmitDone : undefined} />
        </div>
      </Container>
    </section>
  );
};

export default Form;
